import { render } from 'react-dom';

import Bowser from 'bowser';
import { get } from 'lodash';
import { parse, stringify } from 'query-string';
import UAParser from 'ua-parser-js';

import { alertWithoutTitle } from './alert';

const isFromLineApp = new UAParser().getUA().includes('LIFF');
const liff = process.env.NODE_ENV === 'development' && !isFromLineApp ? require('./mockLiff') : window.liff;

export default liff;

export const renderLiff = (element, container, callback) => {
  const { liffId } = parse(window.location.search);
  liff
    .init({ liffId })
    .then(() => render(element, container, callback))
    .catch(err => {
      if (!liffId && err.code === 'INVALID_CONFIG') {
        const lineVer = liff.getLineVersion();
        alertWithoutTitle(`LINE 版本${lineVer ? `(${lineVer})` : ''}過舊。請確認 LINE 版本大於 v9.14.0 以正常使用。`);
      }
    });
};

export const detectUA = ({ retry = false, path = '/', params = {} } = {}) => {
  const {
    os: { name: osName, version: osVersion },
    browser: { name: browser },
    platform,
  } = Bowser.getParser(window.navigator.userAgent).parsedResult;
  const isIOS = /ios/i.test(osName);
  const isAndroid = /android/i.test(osName);
  const isFirefox = /firefox/i.test(browser);

  const { full: fullLiffId } = __LIFF_ID__;

  let appUrl = '';
  if (!retry) {
    // if user opens the page in external browser, try to redirect back to LINE
    appUrl = `https://liff.line.me/${fullLiffId}${path}?${stringify({ ...params, liffId: fullLiffId, retry: true })}`;
  } else {
    // if already retried but till in external browser, the user might not install LINE
    if (isIOS) {
      appUrl = 'https://apps.apple.com/tw/app/line/id443904275';
    }
    if (isAndroid) {
      appUrl = 'https://play.google.com/store/apps/details?id=jp.naver.line.android';
    }
  }
  return {
    isIOS,
    isAndroid,
    appUrl,
    isFirefox,
    platform,
    osVersion: Number(osVersion.split('.', 2).join('.')), // ensure there is at most one decimal point
  };
};

export const getLineId = async () => {
  let lineId;
  try {
    const profile = await liff.getProfile();
    lineId = get(profile, 'userId');
  } catch (error) {
    if (error.code === 'UNAUTHORIZED') {
      liff.login({ redirectUri: window.location });
      return lineId;
    }
    throw error;
  }
  return lineId;
};
